import { Link, useParams } from "react-router-dom";

import { Users, Mail } from "lucide-react";

import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarSeparator,
} from "../../components/ui/sidebar";

const ProjectAccessSidebar = () => {
  const { projectId } = useParams();

  return (
    <>
      <SidebarSeparator className="mt-2" />

      <SidebarGroup>
        <SidebarGroupLabel>Project Access</SidebarGroupLabel>

        <SidebarGroupContent>
          <SidebarMenu>
            <Link to={`/projects/${projectId}/access/members`}>
              <SidebarMenuItem>
                <SidebarMenuButton asChild tooltip="Members">
                  <div>
                    <Users />
                    <span>Members</span>
                  </div>
                </SidebarMenuButton>
              </SidebarMenuItem>
            </Link>

            <Link to={`/projects/${projectId}/access/invites`}>
              <SidebarMenuItem>
                <SidebarMenuButton asChild tooltip="Invites">
                  <div>
                    <Mail />
                    <span>Invites</span>
                  </div>
                </SidebarMenuButton>
              </SidebarMenuItem>
            </Link>
          </SidebarMenu>
        </SidebarGroupContent>
      </SidebarGroup>
    </>
  );
};

export default ProjectAccessSidebar;
